/**
 * Enum for api status values.
 * @readonly
 * @enum {number}
 */

export enum ApiStatusCode {
  Unauthorized = 401,
  BadRequest = 400,
  Forbidden = 403,
  NotFound = 404,
  TimeOut = 408,
  InternalServerError = 500,
}